// extracted by mini-css-extract-plugin
export default {"container":"Spinner-container___mzINr","container_hidden":"Spinner-container_hidden___9tBNV","spinner":"Spinner-spinner___V-C7h","spinner-rotate":"Spinner-spinner-rotate___NVW6b"};